module.exports = __webpack_public_path__ + "img/banner2.137e8833.png";